import { React, useState, useEffect, createContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../../Helpers/API";
import {
    TextField,
    MenuItem,
    InputAdornment,
    Modal,
    Box
} from "@mui/material";
import Swal from "sweetalert2";
// import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from '@mui/icons-material/Edit';
import EditarDatosContactoModal from "./EditarDatosContactoModal";

const RegistrarContactoModal = ({ open, onClose, idcliente }) => {
    const [ContactoNuevo, setContactoNuevo] = useState({
        idmedio: -99,
        mediocontacto: "",
        medio: "",
        responsable: "",
        comentarios: "",
    });
    const [datosContacto, setDatosContacto] = useState([]);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [ejecucionEliminar, setEjecucionEliminar] = useState(false);
    const [ejecucionGuardar, setEjecucionGuardar] = useState(false);
    const [selectedContacto, setSelectedContacto] = useState([]);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModalEditar = (idmedio) => {
        setOpenModalEditar(true);
        setSelectedContacto(idmedio);
    };

    const handleCloseModalEditar = () => {
        setOpenModalEditar(false);
        // cargarContactos();
    };


    useEffect(() => {
        if (open && idcliente) {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ObtenerDatosContactoCliente/DatosContacto?idcliente=${idcliente}`)
                .then((result) => {
                    setDatosContacto(result);
                    setLoader({ ...loader, mostrar: false });
                    setEjecucionGuardar(false);
                    setEjecucionEliminar(false);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
                });
        }
    }, [open, idcliente, openModalEditar, ejecucionGuardar, ejecucionEliminar]);


    const guardarContacto = () => {
        if (ContactoNuevo.mediocontacto === "" || ContactoNuevo.mediocontacto === null || ContactoNuevo.mediocontacto === undefined) {
            Swal.fire({
                title: "AGREGAR CONTACTO",
                text: "SELECCIONE EL MEDIO DE CONTACTO",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        if (ContactoNuevo.medio === "" || ContactoNuevo.medio === null || ContactoNuevo.medio === undefined) {
            Swal.fire({
                title: "AGREGAR CONTACTO",
                text: "SE NECESITA AGREGAR EL CORREO O TELEFONO",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return; // Detiene la ejecución si no hay facturas seleccionadas
        }

        setLoader({ ...loader, mostrar: true });
        const post = {
            idmedio: ContactoNuevo.idmedio,
            idcliente: idcliente,
            mediocontacto: ContactoNuevo.mediocontacto,
            medio: ContactoNuevo.medio,
            comentarios: ContactoNuevo.comentarios,
            responsable_pago: ContactoNuevo.responsable
        };
        request
            .post(`ContactoClienteModal/Guardar`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                setContactoNuevo({
                    ...ContactoNuevo,
                    idmedio: -99,
                    mediocontacto: "",
                    medio: "",
                    comentarios: "",
                })
                await Swal.fire({
                    title: "AGREGAR CONTACTO",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setEjecucionGuardar(true);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    };

    const getMedioContacto = (medio) => {
        switch (medio) {
            case 'W ' || 'W':
                return 'Whatsapp';
            case 'C ' || 'C':
                return 'Correo';
            case 'P ' || 'P':
                return 'Página web';
            case 'T ' || 'T':
                return 'Teléfono';
            default:
                return medio;
        }
    };
    // console.log(datosContacto)

    const onEliminar = (idmedio) => {
        Swal.fire({
            title: "ELIMINAR CONTACTO",
            text: "Esta acción eliminará el contacto. No podrás deshacerla.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            customClass: {
                container: "mi-superpoop",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                setLoader({ ...loader, mostrar: true });
                request
                    .get(`ObtenerDatosContactoCliente/DatosEliminar?idmedio=${idmedio}`)
                    .then(async (result) => {
                        setLoader({ ...loader, mostrar: false });
                        await Swal.fire({
                            title: "ELIMINAR CONTACTO",
                            text: "Registro eliminado con éxito",
                            icon: "success",
                            customClass: {
                                container: "mi-superpoop",
                            },
                        });
                        setEjecucionEliminar(true);
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
                    });
            }
        });
    };


    // console.log(datosContacto)
    return (
        <Modal open={open} onClose={onClose}>
            <div className="plantilla-screen-filtro-container-modal-container">
                <div className="agregar-contacto-modal">
                    <div className="agregar-contacto-modal-detalle">
                        <div className="agregar-contacto-modal-detalle-formulario">
                            <div className="agregar-contacto-modal-formulario-plantilla">
                                <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                                    <PlantillaScreen
                                        titulo={`Registrar Datos de Contacto`}
                                        className_main={1}
                                        className={"plantilla-screen-filtro-container-modal"}
                                    >
                                        <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                        <div
                                            className={`agregar-contacto-modal-formulario-plantilla-agregar`}
                                        >
                                            <div className="agregar-contacto-modal-formulario-plantilla-container scroll-4">

                                                <Box display="flex" sx={{ mt: 2 }}>
                                                    <TextField
                                                        className="input-medio-comunicacion"
                                                        fullWidth
                                                        size="small" // Asegúrate de que ambos tengan el mismo tamaño
                                                        label="Medio de Contacto"
                                                        select
                                                        value={ContactoNuevo.mediocontacto}
                                                        onChange={(e) => {
                                                            setContactoNuevo({
                                                                ...ContactoNuevo,
                                                                mediocontacto: e.target.value,
                                                            });
                                                        }}
                                                        sx={{ flex: 1, mr: 1 }}
                                                    >
                                                        <MenuItem value={"T"}>Teléfono</MenuItem>
                                                        <MenuItem value={"W"}>WhatsApp</MenuItem>
                                                        <MenuItem value={"C"}>Correo</MenuItem>
                                                        <MenuItem value={"P"}>Página Web</MenuItem>
                                                    </TextField>

                                                    <TextField
                                                        id="outlined-multiline-static"
                                                        size="small" // Añade size="small" aquí
                                                        label={
                                                            ContactoNuevo.mediocontacto === "C"
                                                                ? "Correo"
                                                                : ContactoNuevo.mediocontacto === "P"
                                                                    ? "Página Web"
                                                                    : "Teléfono"
                                                        }
                                                        value={ContactoNuevo.medio}
                                                        onChange={(e) => {
                                                            setContactoNuevo({
                                                                ...ContactoNuevo,
                                                                medio: e.target.value,
                                                            });
                                                        }}
                                                        inputProps={{
                                                            type: ContactoNuevo.mediocontacto === "T" || ContactoNuevo.mediocontacto === "W" ? 'number' : 'text',
                                                            style: { height: '23px' },
                                                            onInput: (e) => {
                                                                if (ContactoNuevo.mediocontacto === "T" || ContactoNuevo.mediocontacto === "W") {
                                                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Eliminar caracteres no numéricos
                                                                    // Limitar longitud a 10
                                                                    if (value.length <= 10) {
                                                                        e.target.value = value;
                                                                    } else {
                                                                        e.target.value = value.slice(0, 10);
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                        sx={{ flex: 1 }} // Mantén flex: 1 aquí
                                                    />
                                                </Box>

                                                <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                                                    <TextField
                                                        id="outlined-multiline-static"
                                                        label="Responsable de Pago"
                                                        value={ContactoNuevo.responsable}
                                                        onChange={(e) => {
                                                            setContactoNuevo({
                                                                ...ContactoNuevo,
                                                                responsable: e.target.value
                                                            });
                                                        }}
                                                        inputProps={{
                                                            style: { height: '10px' },
                                                        }}
                                                        fullWidth
                                                    />

                                                    <TextField
                                                        id="outlined-multiline-static"
                                                        label="Comentarios"
                                                        value={ContactoNuevo.comentarios}
                                                        onChange={(e) => {
                                                            setContactoNuevo({
                                                                ...ContactoNuevo,
                                                                comentarios: e.target.value
                                                            });
                                                        }}
                                                        inputProps={{
                                                            style: { height: '10px' },
                                                        }}
                                                        fullWidth
                                                    />
                                                </Box>

                                            </div>
                                            <div className="agregar-contacto-modal-buttons">
                                                <button
                                                    className="agregar-contacto-modal-button-guardar"
                                                    onClick={() => guardarContacto()}
                                                >
                                                    Agregar
                                                </button>
                                            </div>

                                            <div className="agregar-contacto-table scroll-4">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Medio de Contacto</th>
                                                            <th>
                                                                <div>Medio</div>
                                                            </th>

                                                            <th>
                                                                <div>Responsable</div>
                                                            </th>

                                                            <th>
                                                                <div>Comentarios</div>
                                                            </th>

                                                            <th>
                                                                <div>Opciones</div>
                                                            </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {datosContacto.map((dc) => (
                                                            <tr key={dc.idmedio}>
                                                                <td className="ta-center">{getMedioContacto(dc.medio_contacto)}</td>
                                                                <td className="ta-comentario">{dc.medio}</td>
                                                                <td className="ta-comentario">{dc.responsable_pago}</td>
                                                                <td className="ta-comentario">{dc.comentarios}</td>
                                                                <td>
                                                                    <div className="listado-contacto-button">
                                                                        <div className="editar"
                                                                            onClick={() => handleOpenModalEditar(dc.idmedio)}
                                                                        >
                                                                            <EditIcon /> Editar
                                                                        </div>
                                                                        <div className="eliminar"
                                                                            onClick={() => onEliminar(dc.idmedio)}
                                                                        >
                                                                            <DeleteIcon /> Eliminar
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </PlantillaScreen>
                                    <EditarDatosContactoModal open={openModalEditar} handleCloseModalEditar={handleCloseModalEditar} idmedio={selectedContacto} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    );
};


export default RegistrarContactoModal;